import { Injectable, inject } from '@angular/core';
import { LocalStorageService } from './localStorage.service';
import { PLANNER_MODE_STORAGE_KEY, PLANNER_MODE_TTL_SECONDS } from '../interfaces';

/**
 * T10797: guarda el modo planificador con caducidad.
 *
 * El modo se enciende con `?planner=1` (canal del CMS) y antes quedaba pegado en el
 * navegador para siempre. Aquí vive el único sitio que escribe la clave, para que el
 * plazo se aplique siempre igual: 10 minutos que se renuevan mientras se navegue.
 */
@Injectable({ providedIn: 'root' })
export class PlannerModeService {
  private _localStorageService = inject(LocalStorageService);

  /** Enciende el modo (o reinicia su plazo) durante PLANNER_MODE_TTL_SECONDS. */
  public enable(): void {
    this._localStorageService.setItem(PLANNER_MODE_STORAGE_KEY, true, PLANNER_MODE_TTL_SECONDS);
  }

  /** ¿Sigue vigente? Una clave caducada la borra el propio LocalStorageService al leerla. */
  public isEnabled(): boolean {
    return this._localStorageService.getItem<boolean>(PLANNER_MODE_STORAGE_KEY) === true;
  }

  /**
   * Renueva el plazo solo si el modo sigue vigente: si ya caducó, no lo resucita.
   * Se llama en cada navegación, así que quien está planificando no se queda fuera.
   */
  public keepAlive(): void {
    if (!this.isEnabled())
      return;

    this.enable();
  }

  public disable(): void {
    this._localStorageService.removeItem(PLANNER_MODE_STORAGE_KEY);
  }
}
